export function arraysSubtract<T>(array1: T[], array2: T[]): T[] {
  const a = array1 || []
  const b = array2 || []

  return a.filter(x => !b.includes(x))
}

export function arrayIntersection<T>(array1: T[], array2: T[]): T[] {
  const a = array1 || []
  const b = array2 || []

  return a.filter(x => b.includes(x))
}

export function arraysHasSameElements<T>(array1?: T[], array2?: T[]): boolean {
  const sortedArray1 = [...(array1 || [])].sort()
  const sortedArray2 = [...(array2 || [])].sort()

  return areArraysSame<T>(sortedArray1, sortedArray2)
}

export function areArraysSame<T>(array1: T[], array2: T[]): boolean {
  const a1 = array1 || []
  const a2 = array2 || []

  return a1.length === a2.length && a1.every((value, index) => value === a2[index])
}

export function uniqueValues<T>(array: T[]): T[] {
  return Array.from(new Set(array))
}

export function normalizeToArray<T>(value: T | T[]): T[] {
  if (Array.isArray(value)) return value

  return value ? [value] : []
}
